import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/fonts/Roboto-Regular.ttf', fontWeight: 'normal' }],
});

// Stessi token di SintesiCdAIdraulica.styles.js — pattern per-file già in
// uso in tutte le Sintesi CdA (nessuno stylesheet condiviso fra loro), vedi
// commento in testa a SintesiL3Idraulico.jsx.
export const styles = StyleSheet.create({
  page: {
    padding: '1cm 0.75cm 0.3cm',
  },
  title: {
    fontSize: '16pt',
    lineHeight: 1.2,
    fontFamily: 'Helvetica-Bold',
    marginBottom: '10pt',
  },
  textForSymbol: {
    fontFamily: 'Roboto',
  },
  wrapperCdA: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
    alignItems: 'center',
  },
  tagTextWhiteTitle: {
    textAlign: 'center',
    fontSize: '12pt',
    color: 'white',
    fontFamily: 'Helvetica-Bold',
  },
  infoTagGreyTitle: {
    padding: '0.2cm',
    backgroundColor: '#DBDCDD',
    borderRadius: '16pt',
    marginLeft: '5pt',
    width: '120pt',
  },
  infoTagGrey: {
    padding: '0.1cm',
    backgroundColor: '#DBDCDD',
    borderRadius: '16pt',
    width: '50pt',
    marginLeft: '3pt',
    marginTop: '-6pt',
  },
  infoTagBlue: {
    padding: '0.1cm',
    backgroundColor: '#3260CE',
    borderRadius: '16pt',
    width: '50pt',
    marginLeft: '3pt',
    marginTop: '-6pt',
  },
  infoTagOutline: {
    padding: '0.1cm',
    borderRadius: '16pt',
    backgroundColor: 'white',
    border: '1px solid black',
    width: '80pt',
    marginLeft: '3pt',
    marginTop: '-6pt',
  },
  infoLabel: {
    fontSize: '8pt',
    lineHeight: 2,
    fontFamily: 'Helvetica-Bold',
  },
  infoData: {
    fontSize: '8pt',
    lineHeight: 2,
    color: 'grey',
    fontFamily: 'Helvetica',
    marginLeft: '3pt',
  },
  infoDataMaxWidth: {
    fontSize: '8pt',
    lineHeight: 2,
    color: 'grey',
    fontFamily: 'Helvetica',
    maxWidth: '90%',
  },

  imagesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '16pt',
  },
  captionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '3pt',
  },
  caption: {
    width: '49%',
    textAlign: 'left',
  },
  image: {
    width: '49%',
    height: '140pt',
    borderRadius: '10pt',
    objectFit: 'cover',
  },
  placeholderImage: {
    width: '49%',
    height: '140pt',
    backgroundColor: '#F4F5F6',
    borderRadius: '10pt',
  },
  container: {
    borderRadius: '18pt',
    border: '1px solid #C3C3C3',
    marginTop: '0.20cm',
    marginBottom: '0.10cm',
    padding: '0.45cm',
  },
  // Altezza fissa condivisa dai box "Fenomeno di Sormonto"/"Fenomeni di
  // Erosione": a contenuto libero i due box hanno un numero diverso di
  // righe (3 vs 4, più l'etichetta lunga "Protezione al piede..." che va
  // a capo) e risultavano di altezza diversa — stesso problema/pattern già
  // risolto per il gemello L2 (SintesiCdAIdraulica.jsx, height fissa sul
  // solo box Sormonto lì). Qui su entrambi per sicurezza, tarata sul
  // contenuto più alto (Erosione, 4 righe + etichetta su 2 righe + valore
  // su riga propria — issue #1029, label e valore non più affiancati sulla
  // stessa riga per evitare la sovrapposizione, vedi SintesiL3Idraulico.jsx).
  phenomenonContainer: {
    height: '151pt',
  },
  titleH2: {
    fontSize: '12pt',
    fontFamily: 'Helvetica-Bold',
    marginBottom: '0.35cm',
  },
  titleH3: {
    fontSize: '9.5pt',
    fontFamily: 'Helvetica-Bold',
    marginBottom: '0.25cm',
  },

  infoTagFenomeni: {
    padding: '0.15cm',
    backgroundColor: '#DBDCDD',
    borderRadius: '16pt',
    marginBottom: '6pt',
    marginTop: '-5pt',
    width: '35%',
  },

  tagTextInSection: {
    textAlign: 'center',
    fontSize: '7pt',
    color: 'white',
    textTransform: 'uppercase',
    fontFamily: 'Helvetica-Bold',
  },

  iconElementContainer: {
    width: 8,
    height: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 6,
  },

  formData: {
    position: 'absolute',
    bottom: 8,
  },

  tagText: {
    textAlign: 'center',
    fontSize: '6pt',
    color: 'white',
    textTransform: 'uppercase',
  },

  // Box "Esito della valutazione" (609) — a differenza della riga a 5
  // pillole del riepilogo web (che mostra sempre tutte le opzioni per dare
  // il contesto della scala), nel PDF si mostra SOLO l'opzione valorizzata:
  // niente più larghezza percentuale tarata su una riga di 5, `auto` con un
  // minimo perché il singolo box non risulti minuscolo. `alignSelf:
  // 'flex-start'` perché in colonna (m.dangelo, punto 3 — ID609 può avere
  // più risposte) il contenitore è `flexDirection: 'column'`, e senza
  // questo Yoga stira il box alla larghezza piena del contenitore invece di
  // lasciarlo dimensionato sul contenuto.
  esitoBox: {
    width: 'auto',
    alignSelf: 'flex-start',
    minWidth: '90pt',
    minHeight: '30pt',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8pt',
    border: '1px solid #C3C3C3',
    backgroundColor: 'white',
    padding: '6pt 12pt',
  },
  esitoBoxActive: {
    border: '1px solid #3260CE',
    backgroundColor: '#3260CE',
  },
  esitoBoxText: {
    fontSize: '6.5pt',
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    color: 'black',
  },
  esitoBoxTextActive: {
    color: 'white',
  },
});
